import angular from 'angular';

angular.module('cxTaskflow', ['commonServices']);
